module.exports = __webpack_public_path__ + "img/Female.4bfb1f7f.png";